import "./contact-form.css";
import { useContact } from "../hooks/use-contact.ts";

export const ContactForm = () => {
  const { values, status, error, isSubmitting, updateField, submit } =
    useContact();

  return (
    <section className="contact-shell" id="contact" aria-labelledby="contact-title">
      <div className="contact-copy">
        <span className="contact-kicker">Available for thoughtful builds</span>
        <h2 id="contact-title">Let&apos;s create something useful.</h2>
        <p>
          Send a few details about your project, collaboration, or product idea
          and I&apos;ll get back to you with a clear next step.
        </p>
      </div>

      <form className="contact-card" onSubmit={submit} noValidate>
        <div className="contact-field">
          <label htmlFor="contact-name">Name</label>
          <input
            id="contact-name"
            name="name"
            type="text"
            autoComplete="name"
            value={values.name}
            onChange={updateField("name")}
            disabled={isSubmitting}
            required
          />
        </div>

        <div className="contact-field">
          <label htmlFor="contact-email">Email</label>
          <input
            id="contact-email"
            name="email"
            type="email"
            autoComplete="email"
            value={values.email}
            onChange={updateField("email")}
            disabled={isSubmitting}
            required
          />
        </div>

        <div className="contact-field">
          <label htmlFor="contact-message">Message</label>
          <textarea
            id="contact-message"
            name="message"
            rows={5}
            value={values.message}
            onChange={updateField("message")}
            disabled={isSubmitting}
            required
          />
        </div>

        <button className="contact-submit" type="submit" disabled={isSubmitting}>
          {isSubmitting ? "Sending..." : "Send message"}
        </button>

        <div className="contact-status" role="status" aria-live="polite">
          {status === "success" && "Thanks. Your message is on its way."}
          {status === "error" && error}
        </div>
      </form>
    </section>
  );
};
